<template>
  <select v-model="handler" @change="input" class="form-control">
    <option value="normal">{{_lang('stretch','input')}}</option>
    <option value="flex-start">{{_lang('top','input')}}</option>
    <option value="center">{{_lang('center','input')}}</option>
    <option value="flex-end">{{_lang('bottom','input')}}</option>
    <option value="baseline">{{_lang('baseline','input')}}</option>
  </select>
</template>

<script>
export default {
  props: ['value'],
  data(){
      return {
          handler:null,
      }
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    input(){
        this.$emit('change',this.handler);
    },

  }

}
</script>
